(function () {
  function activate(root, panelId) {
    var tabs = root.querySelectorAll('[data-dlux-tab]');
    var panels = root.querySelectorAll('[data-dlux-panel]');
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-panel') === panelId;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach(function (panel) {
      var on = panel.id === panelId;
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  document.querySelectorAll('[data-dlux-product-tabs]').forEach(function (root) {
    root.querySelectorAll('[data-dlux-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-panel');
        if (id) activate(root, id);
      });
    });
  });
})();
